const actions = {
  SET_STATE: 'metrics/SET_STATE',
  GET_METRICS: 'metrics/GET_METRICS',
  GET_METRICS_BY_FILTER: 'metrics/GET_METRICS_BY_FILTER',
}

export default actions
